import { render, staticRenderFns } from "./productModule.vue?vue&type=template&id=2d683621&scoped=true"
import script from "./productModule.vue?vue&type=script&lang=js"
export * from "./productModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d683621",
  null
  
)

export default component.exports